module.exports = __webpack_public_path__ + "img/fk_grand.4bcc2d14.jpg";